var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title)?_c('div',[_c('v-card-title',{staticClass:"module-title",class:_vm.moduleClass},[_c('div',{staticClass:"text-h5 text-uppercase font-weight-light"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('v-divider')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }